import { InputRow, ModelNewNumericInput } from '@equifinance/shared';

export function PayslipEvidence({
  payslipsEvidence,
  field,
}: {
  payslipsEvidence: 'payslipsEvidence' | 'remittanceSlipsEvidence',
  field: string,
}) {
  const fieldPath = `${field}.${payslipsEvidence}`;

  return (
    <InputRow>
      <ModelNewNumericInput
        label="Total gross annual income"
        field={`${fieldPath}.grossAnnualIncome`}
        prefix="£"
        isFixedDecimal
        required
        maxCharacters={10}
      />
      <ModelNewNumericInput
        label="Net monthly income"
        field={`${fieldPath}.netMonthlyIncome`}
        prefix="£"
        isFixedDecimal
        required
        maxCharacters={10}
      />
    </InputRow>
  );
}
